import ChevronRight12 from '@moda/icons/chevron-right-16';
import { Clickable, Input, LoadingBalls, Stack, Text } from '@moda/om';
import React, { FC, useCallback, useState } from 'react';
import CheckmarkIcon from '@moda/icons/checkmark-16';
import { DesignerQuery } from '../../../generated/types';
import { useDesignerSubscribe } from '../../../hooks/useEmailSubscribe/useDesignerSubscribe';

import './DesignerEmailSubscribingButton.scss';

type Designer = NonNullable<DesignerQuery['designer']>;

interface Props {
  designer: Designer;
}

export const DesignerEmailSubscribingButton: FC<Props> = ({ designer }) => {
  const { subscribeToDesigner, loading, error, isSubscribed, mailValidationError } =
    useDesignerSubscribe();
  const [email, setEmail] = useState<string>('');

  const handleSubmit = useCallback(
    (event: React.FormEvent) => {
      event.preventDefault();
      subscribeToDesigner(email, designer);
    },
    [designer, email, subscribeToDesigner]
  );

  if (!subscribeToDesigner) return null;

  return (
    <form onSubmit={handleSubmit}>
      <Stack
        alignItems="center"
        className="DesignerEmailSubscribingButton"
        direction="horizontal"
        justifyContent="space-between"
        space={2}
      >
        <Input
          className="DesignerEmailSubscribingButton__input"
          disabled={isSubscribed}
          placeholder="Enter Your Email"
          onChange={value => !isSubscribed && setEmail(value.trim())}
          required
          error={mailValidationError}
          value={email}
        />

        {!isSubscribed && (
          <>
            {loading && <LoadingBalls />}

            {!loading && (
              <Clickable type="submit">
                <ChevronRight12 />
              </Clickable>
            )}
          </>
        )}

        {isSubscribed && <CheckmarkIcon />}
      </Stack>

      {error && (
        <div className="DesignerEmailSubscribingButton__error">
          <Text color="code-red">Unable to subscribe you at this time</Text>
        </div>
      )}
    </form>
  );
};
